import React from 'react';
import BrandLogo from '../components/BrandLogo';

const Maintenance = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#0409A3] to-[#141a5c] px-6 text-center text-white">
      <BrandLogo variant="white" className="mb-10 h-7" />
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#34D0E3]">
        Mantenimiento programado
      </p>
      <h1 className="max-w-xl font-outfit text-3xl uppercase leading-tight sm:text-4xl">
        Estamos actualizando la plataforma
      </h1>
      <p className="mt-5 max-w-md text-sm leading-relaxed text-[#C9D2FF]">
        Selltrix no está disponible en este momento mientras realizamos mejoras. Volveremos a estar
        en línea en breve — gracias por tu paciencia.
      </p>
    </div>
  );
};

export default Maintenance;
